'use strict';

// Existing English auth copy, shared by the Pug website and native/app forms.
module.exports = {
  "shell": {
    "titleLines": ["AI that works.", "For you."],
    "subtitle": "Less busywork. More possibility.",
    "benefits": [
      ["comments", "A fresh perspective", "Think, ask, and explore with Chat."],
      ["briefcase", "A finished result", "Research, write, and create with Work."]
    ],
    "legal": "By continuing, you agree to our"
  },
  "auth": {
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "login": {
      "title": "Welcome back to %APP_NAME%",
      "subtitle": "Enter your email and password to continue.",
      "emailLabel": "Email address",
      "passwordLabel": "Password",
      "submitButton": "Log In",
      "noAccount": "Don't have an account?",
      "signupLink": "Sign up",
      "forgotPassword": "Forgot password?",
      "checkingBrowser": "Checking browser security. Complete the security check if one appears.",
      "errors": {
        "invalidEmail": "Please enter a valid email address",
        "emailRequired": "Please enter your email address",
        "passwordRequired": "Please enter your password",
        "passwordTooShort": "Password must be at least 8 characters long",
        "loginFailed": "Failed to login. Please try again.",
        "wrongPassword": "Incorrect password. Please try again or reset your password.",
        "accountNotFound": "No account found with that email address.",
        "captchaRequired": "The browser security check could not finish. This is separate from email verification. Please try logging in again.",
        "browserCheckFailed": "The browser security check could not finish. This is separate from email verification. Try Log In again, or sign in with Google or Apple using the same email address.",
        "browserCheckUnavailable": "The browser security check could not load. This is separate from email verification. Allow Cloudflare in your content blocker and try Log In again, or try another browser. You can also sign in with Google or Apple using the same email address.",
        "browserCheckTimedOut": "The browser security check timed out. This is separate from email verification. Try Log In again and complete any security check that appears, or sign in with Google or Apple using the same email address."
      }
    },
    "signup": {
      "title": "Create your %APP_NAME% account",
      "referralInvitationSaved": "Your referral invitation",
      "referralOpenApp": "Open in app",
      "referralInstallHelp": "After installing, return here and open the app to keep your referral, or create your account here first.",
      "referralDesktopHelp": "Create your account here, then sign in to the app. Your credits follow your account.",
      "subtitle": "Enter your email and password to get started.",
      "emailLabel": "Email address",
      "passwordLabel": "Password",
      "submitButton": "Sign Up",
      "checkingBrowser": "Checking browser security. Complete the security check if one appears.",
      "haveAccount": "Already have an account?",
      "loginLink": "Log in",
      "errors": {
        "emailRequired": "Please enter your email address",
        "invalidEmail": "Please enter a valid email address",
        "passwordRequired": "Please enter your password",
        "passwordTooShort": "Password must be at least 8 characters long",
        "signupFailed": "Failed to sign up. Please try again.",
        "captchaRequired": "Please complete the verification to continue.",
        "browserCheckFailed": "The browser security check could not finish. Your account has not been created. Try Sign Up again, or use Google or Apple.",
        "browserCheckUnavailable": "The browser security check could not load. Allow Cloudflare in your content blocker and try Sign Up again, or try another browser. You can also use Google or Apple.",
        "browserCheckTimedOut": "The browser security check timed out. Try Sign Up again and complete any security check that appears, or use Google or Apple."
      }
    },
    "forgotPassword": {
      "title": "Reset your password",
      "subtitle": "Enter your email address and we'll send you instructions to reset your password.",
      "emailLabel": "Email address",
      "submitButton": "Send Reset Instructions",
      "backToLogin": "Back to login",
      "rememberPassword": "Remember your password?",
      "success": "Reset instructions have been sent to your email.",
      "ssoOnlyMessage": "This account uses social login. Please sign in with Google or Apple instead.",
      "errors": {
        "captchaRequired": "Please verify you are human by completing the captcha.",
        "emailRequired": "Please enter your email address",
        "invalidEmail": "Please enter a valid email address",
        "resetFailed": "Failed to send reset instructions. Please try again."
      }
    },
    "resetPassword": {
      "title": "Reset your password",
      "subtitle": "Enter your new password to continue.",
      "emailLabel": "Email address",
      "passwordLabel": "New password",
      "confirmPasswordLabel": "Confirm new password",
      "submitButton": "Reset Password",
      "verifyingToken": "Verifying reset link...",
      "pleaseWait": "Please wait while we verify your reset link.",
      "errorTitle": "Reset link invalid",
      "rememberYourPassword": "Remember your password?",
      "loginLink": "Log in",
      "successTitle": "Password reset successfully",
      "successMessage": "Your password has been reset successfully. You can now log in to your account.",
      "goToLogin": "Go to Login",
      "errors": {
        "noToken": "Invalid reset link. No token provided.",
        "invalidToken": "Invalid or expired reset link.",
        "verificationFailed": "Failed to verify reset link. Please try again.",
        "emailRequired": "Please enter your email address",
        "invalidEmail": "Please enter a valid email address",
        "passwordRequired": "Please enter your new password",
        "passwordTooShort": "Password must be at least 8 characters long",
        "passwordsDoNotMatch": "Passwords do not match",
        "captchaRequired": "Please verify you are human by completing the captcha.",
        "resetFailed": "Failed to reset password. Please try again."
      }
    },
    "verifyEmail": {
      "title": "Verify your email",
      "loadingTitle": "Verifying your email...",
      "loadingSubtitle": "Please wait while we verify your email address.",
      "successTitle": "Email verified!",
      "successTitleReward": "%CREDITS% credits added",
      "successSubtitle": "Your email has been verified successfully. You can now log in to your account.",
      "successSubtitleReward": "Thanks for confirming it's you. Your %CREDITS% bonus credits are in your account — log in to use them.",
      "successSubtitleLoggedIn": "Thanks for confirming it's you. You're all set.",
      "successSubtitleRewardLoggedIn": "Thanks for confirming it's you. Your %CREDITS% bonus credits are already in your account.",
      "errorTitle": "Verification failed",
      "errors": {
        "noToken": "Invalid verification link. No token provided.",
        "invalidToken": "Invalid or expired verification link.",
        "verificationFailed": "Failed to verify email. Please try again."
      },
      "buttons": {
        "goToLogin": "Go to Login",
        "backToApp": "Back to Gab AI"
      }
    },
    "sso": {
      "signUpWithGoogle": "Sign up with Google",
      "signInWithGoogle": "Sign in with Google",
      "signUpWithApple": "Sign up with Apple",
      "signInWithApple": "Sign in with Apple",
      "or": "or",
      "errors": {
        "googleFailed": "Google sign-in failed. Please try again.",
        "appleFailed": "Apple sign-in failed. Please try again."
      }
    }
  },
  "mfa": {
    "authenticatorInstructions": "Enter the code from your authenticator app, or choose another enabled method below.",
    "emailInstructions": "Enter the code sent to your verified account email. Check spam if it has not arrived.",
    "sendEmail": "Email me a code",
    "useEmail": "Use the emailed code",
    "backupInstructions": "Enter one of the backup codes you saved when enabling two-factor authentication.",
    "resendEmail": "Resend email code",
    "emailFailed": "Could not send an email code. Use an authenticator or backup code, or try again.",
    "useBackupCode": "Use a backup code",
    "useAuthenticator": "Use an authenticator code",
    "verificationCode": "Verification code",
    "missingSession": "Missing or expired MFA session. Please login again.",
    "enterCode": "Please enter your verification code.",
    "verifyAndLogin": "Verify and login",
    "backToLogin": "Back to login",
    "verifyFailed": "Verification failed. Please try again."
  },
  "mfaPage": {
    "mfaTitle": "Two‑factor authentication",
    "mfaSubtitle": "Enter your code to complete login",
    "mfaMetaTitle": "MFA Verification",
    "mfaMetaDescription": "Verify your identity to complete sign‑in."
  }
};
